export default "__VITE_ASSET__dc5fea1b__"